import Dropdown from 'components/Dropdown/Dropdown'
import TextInput from 'components/TextInput/TextInput'
import Switch from 'react-switch'
import { useEffect, useState } from 'react'

const SettingsTab = ({ values, onChange, onSubmit }) => {
  const { loop } = values?.data || {}
  const { loopPointType, count, fadeOut } = loop
  const loopEnabled = count > 0
  const duration = values.duration / 1000

  const [loopFrom, setLoopFrom] = useState(loop.loopFrom)
  const [loopTo, setLoopTo] = useState(loop.loopTo)

  const endPointOptions = [
    { id: 'end', name: 'End of Track' },
    { id: 'custom', name: 'Custom Point' },
  ]

  useEffect(() => {
    const to = Number(loopTo)
    const from = Number(loopFrom)
    if (to >= 0 && to < duration) {
      if (loopPointType === 'end') {
        changeLoopValue('loopTo', to)
      } else if (loopPointType === 'custom' && to < from && from < duration) {
        const newLoop = { ...loop, loopFrom: from, loopTo: to }
        onChange({
          ...values,
          data: {
            ...values.data,
            loop: newLoop,
          },
        })
      }
    }
  }, [loopTo, loopFrom])

  function changeLoopValue(key, value) {
    const newLoop = { ...loop }
    newLoop[key] = value
    onChange({
      ...values,
      data: {
        ...values.data,
        loop: newLoop,
      },
    })
  }

  function handleFieldChange(evt) {
    const isNumber = evt.target.type === 'number'
    const value = isNumber ? Number(evt.target.value) : evt.target.value
    changeLoopValue(evt.target.name, value)
  }

  function handleToggleLooping(value) {
    if (value) {
      onChange({
        ...values,
        data: {
          ...values.data,
          loop: {
            ...loop,
            count: 2,
            fadeOut: true,
          },
        },
      })
    } else {
      changeLoopValue('count', 0)
    }
  }

  function handleLoopPointTypeChange(value) {
    changeLoopValue('loopPointType', value)
    setLoopFrom(duration)
  }

  return (
    <div className="h-full w-full">
      <div className="flex flex-row">
        <h3 className="mb-2">Looping</h3>
        <div className="ml-6">
          <Switch
            onChange={handleToggleLooping}
            checked={loopEnabled}
            uncheckedIcon={false}
            offColor="#111114"
            offHandleColor="#333"
            onColor="#5e263a"
            onHandleColor="#d63b5c"
            checkedIcon={false}
          />
        </div>
      </div>

      {loopEnabled && (
        <>
          <div className="mb-6 w-[150px]">
            <TextInput
              label="Times to Loop"
              value={count}
              name="count"
              onChange={handleFieldChange}
            />
          </div>

          <div className="flex mb-6">
            <div className="w-[150px]">
              <Dropdown
                label="Loop From"
                options={endPointOptions}
                value={loopPointType}
                onChange={handleLoopPointTypeChange}
              ></Dropdown>
            </div>

            {loopPointType === 'custom' && (
              <div className="w-[150px] ml-3">
                <TextInput
                  label=""
                  value={loopFrom}
                  name="loopFrom"
                  onChange={(evt) => setLoopFrom(evt.target.value)}
                  unit="seconds"
                />
              </div>
            )}
          </div>

          <div className="w-[150px] mb-6">
            <TextInput
              label="Loop To"
              type="number"
              value={loopTo}
              name="loopTo"
              onChange={(evt) => setLoopTo(evt.target.value)}
              unit="seconds"
            />
          </div>

          <div className="my-2 flex items-center">
            <div className="flex items-center">
              <input
                id="fade-out"
                type="checkbox"
                checked={fadeOut}
                onChange={(evt) =>
                  changeLoopValue('fadeOut', evt.target.checked)
                }
              />
            </div>
            <div className="ml-2 flex items-center">
              <label htmlFor="fade-out">Fade out after Looping</label>
            </div>
          </div>
        </>
      )}
      <button
        className="button bg-pink mt-4 mb-6"
        onClick={() => onSubmit(values)}
      >
        Save
      </button>
    </div>
  )
}

export default SettingsTab
